<template>
    <div class="modal" v-bind:class="{'is-active' : modalShow}">
        <div class="modal-background"/>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ title }}
                </p>
                <button class="delete" aria-label="close" @click.prevent="hide()" type="button" v-if="showCloseIcon"/>
            </header>
            <section class="modal-card-body">
                <slot/>
            </section>
        </div>
    </div>
</template>

<script>

  export default {
    props: {
      showCloseIcon: {
        type: Boolean,
        default: true
      },
      title: {
        type: String
      }
    },
    data() {
      return {modalShow: false};
    },
    methods: {
      show() {
        this.modalShow = true;
      },
      hide() {
        this.modalShow = false;
      },
      close() {
        this.hide()
      }
    },
    template: `

  `,
  };
</script>
